import accopsHeaderLogo from "../../assets/logo_accops.png";
import { useRecoilValue } from 'recoil';
import { showHeaderState } from "../../atom/atom";
import './Header.css';
const Header: React.FC = () => {
    const showHeader = useRecoilValue(showHeaderState);

  return (
    <>
      {showHeader && (
        <div className="header-cotainer">
          <div className="header-container-left">
            <img
              className="header-logo"
              src={accopsHeaderLogo}
              alt="accops_logo"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
